<template>
  <div>
    <div class="BackupVaultName-title">
      <Breadcrumb>
        <BreadcrumbItem
          to="/resourceConfigurEationManagement/aws/backup/repository"
          >{{ $t("RAM.AWS.Backup.Repository.title") }}</BreadcrumbItem
        >
        <BreadcrumbItem>{{ this.$route.query.backupVaultName }}</BreadcrumbItem>
      </Breadcrumb>
      <Table
        class="date"
        :no-data-text="$t('common.noData')"
        :columns="columns"
        :data="tableDate"
        style="width: 100.1%"
      >
      </Table>
    </div>
  </div>
</template>

<script>
var tableDateVue = {};
export default {
  name: "BackupValutName",
  data() {
    return {
      current: 1,
      dataTotal: 0,
      val: "",
      columns: [
        {
          title: this.$t("RAM.AWS.Backup.Repository.recoveryPointArn"),
          key: "recoveryPointArn",
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.status"),
          key: "status",
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.resourceArn"),
          key: "resourceArn",
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.resourceType"),
          key: "resourceType",
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.creationDate"),
          key: "creationDate",
        },
        {
          title: this.$t("RAM.AWS.Backup.Repository.deleteAfterDaysDesc"),
          key: "deleteAfterDaysDesc",
        },
        {
          title: this.$t(
            "RAM.AWS.Backup.Repository.moveToColdStorageAfterDaysDesc"
          ),
          key: "moveToColdStorageAfterDaysDesc",
        },
      ],
      tableDate: [],
    };
  },
  beforeCreate: function () {
    tableDateVue = this;
  },
  mounted: function () {
    tableDateVue.getElasticResourceData();
  },
  methods: {
    // 显示数据
    /****************************************************/
    getElasticResourceData: function () {
      //列表分页
      this.$api.resourceManagement
        .getBackupVaultDetails({ id: this.$route.query.id })
        .then((res) => {
          this.tableDate = res.data.recoveryPointDTOS;
        });
    },
  },
};
</script>

<style scoped>
.BackupVaultName-title {
  width: 100%;
  font-size: 13px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 15px 0px 15px 4px;
  font-weight: 600;
}
.date {
  margin-top: 20px;
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/configuration/resource_configuration_management/aws/backup/repository/BackupVaultName.vue